import { IPreloadedState } from 'shared/types/redux';

export const selectInfrastructure = (state: IPreloadedState) => state.infrastructure;
